module.exports = __webpack_public_path__ + "static/img/7.598016e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/7.png
// module id = lVG8
// module chunks = 0